import { Controller } from "@hotwired/stimulus"
import { showToast } from "../helpers/toast"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["input"]
  static values = { parentId: Number }

  connect() {
    this.timeout = null
    this.dropdownEl = null
    this.handleClickOutside = this.closeResults.bind(this)
    document.addEventListener("click", this.handleClickOutside)
  }

  disconnect() {
    clearTimeout(this.timeout)
    document.removeEventListener("click", this.handleClickOutside)
    this.dropdownEl?.remove()
  }

  search() {
    clearTimeout(this.timeout)
    const query = this.inputTarget.value.trim()

    if (query.length < 2) {
      this.resultsTarget.innerHTML = ""
      return
    }

    this.timeout = setTimeout(() => this.fetchResults(query), 300)
  }

  async fetchResults(query) {
    const response = await fetch(`/admin/duplicates/search?q=${encodeURIComponent(query)}`)
    const accounts = await response.json()

    this.dropdownEl?.remove()

    const rect = this.inputTarget.getBoundingClientRect()
    const dropdown = document.createElement("div")
    dropdown.className = "fixed z-[9999] mt-1 bg-surface-2 border border-border-subtle rounded-lg shadow-lg w-72 max-h-64 overflow-y-auto"
    dropdown.style.top = `${rect.bottom + window.scrollY}px`
    dropdown.style.left = `${rect.left}px`
    dropdown.dataset.accountAttachDropdown = "true"

    if (accounts.length === 0) {
      dropdown.innerHTML = `<p class="text-xs text-text-muted p-3">Aucun résultat</p>`
    } else {
      dropdown.innerHTML = accounts.map(a => `
        <button type="button"
                class="w-full text-left px-3 py-2 hover:bg-surface-3 rounded-lg transition-colors"
                data-action="click->account-attach#select"
                data-child-id="${a.id}">
          <div class="text-sm font-medium text-text-primary">${this.escapeHtml(a.name)}</div>
          <div class="text-xs text-text-muted">${this.escapeHtml(a.city || "")} · ${a.status}</div>
        </button>
      `).join("")
    }

    document.body.appendChild(dropdown)
    this.dropdownEl = dropdown
  }

  select(event) {
    const childId = event.currentTarget.dataset.childId
    const parentId = this.parentIdValue
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    this.dropdownEl?.remove()
    this.dropdownEl = null

    fetch("/admin/duplicates/attach", {
      method: "PATCH",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": csrfToken
      },
      body: `child_id=${childId}&parent_id=${parentId}`
    }).then(() => {
      showToast("Compte rattaché avec succès")
      Turbo.visit(window.location.href, { action: "replace" })
    })
  }

  closeResults(event) {
    if (!this.element.contains(event.target) && !this.dropdownEl?.contains(event.target)) {
      this.dropdownEl?.remove()
      this.dropdownEl = null
    }
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
